import { protocolAxes, radarAxes } from '../data/protocolData'
// Scoring data from the provided table
const dimensionScores = {
  // Identity options
  'identity-kosher': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
  'identity-halal': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
  'identity-ahimsa': [-1, 0, 0, 1, 1, 0, -1, -1, 0, 0, 1, 1],
  'identity-diabetic': [0, 1, 1, 1, 1, 1, 1, 0, 1, 0, 0, -1],
  'identity-celiac': [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, -1],
  'identity-fodmap': [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, -1],
  'identity-renal': [-1, 0, 1, 0, 0, -1, -1, -1, 0, -1, 0, -1],
  'identity-antihistamine': [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, -1],
  'identity-autoimmune': [0, 1, 1, 1, 1, 0, 1, 0, 0, -1, 0, -1],
  'identity-sattvic': [0, 0, 0, 0, 1, 0, 0, -1, 1, 1, 1, 1],
  'identity-none': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Default for None
  // Meal Frequency options
  'mealFrequency-grazer': [1, -1, 0, 0, -1, 1, -1, -1, -1, 0, 0, -1],
  'mealFrequency-daystride': [0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 1, 1],
  'mealFrequency-sunfast': [0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0, 0],
  'mealFrequency-nightbound': [-1, 1, 1, 0, -1, 1, 1, -1, 0, -1, 0, 0],
  // Food Type options
  'foodType-beast': [0, 1, -1, 0, -1, 1, 1, 1, 0, 0, -1, 0],
  'foodType-tide': [0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0],
  'foodType-plant': [0, 0, 1, 1, 0, 0, 0, -1, 0, 0, 1, 1],
  'foodType-fusion': [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 1],
  // Macronutrient Strategy options
  'macroStrategy-burn': [1, 1, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0],
  'macroStrategy-surge': [1, -1, 0, 0, 0, 0, -1, -1, 0, 0, 0, 0],
  'macroStrategy-flux': [1, 0, 1, 0, 1, 1, 0, 0, 1, 1, 1, 1],
  'macroStrategy-whisper': [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0],
  // Feeding Cycle options
  'feedingCycle-180': [1, 0, -1, 0, 0, 1, 0, 0, 0, 0, 0, 0],
  'feedingCycle-3.4': [1, 1, 0, 0, 0, 1, 0, 0, 0, -1, 0, -1],
  'feedingCycle-6.1': [1, 1, 0, 0, 0, 1, 0, 0, 0, -1, 0, 0],
  'feedingCycle-2.5': [0, 1, 0, 0, 0, 1, 1, 1, 1, -1, 0, -1],
  'feedingCycle-52': [0, 1, 1, 1, 1, 1, 1, -1, 1, 0, 0, 0],
  'feedingCycle-7.0': [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1],
  'feedingCycle-none': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  // Micronutrient Strategy options
  'microStrategy-spice': [0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1],
  'microStrategy-brew': [0, 1, 1, 0, 1, 0, 0, 0, 1, 1, 1, 1],
  'microStrategy-culture': [0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  'microStrategy-marrow': [1, 1, 0, 0, 0, 1, 1, 1, 0, 0, -1, -1],
  'microStrategy-elixir': [1, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, -1],
  'microStrategy-alloy': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  'microStrategy-super': [1, 0, 1, 1, 0, 0, 0, 0, 1, 0, 0, 0],
  // Exercise Timing options
  'exerciseTiming-emp': [-1, 1, 1, 0, 0, 1, 1, -1, 1, 0, 0, 0],
  'exerciseTiming-prm': [1, 0, 0, 0, 0, 1, 0, 0, 1, 1, 0, 0],
  'exerciseTiming-fed': [1, -1, 0, 0, -1, 1, -1, -1, 0, 0, 0, 0],
  'exerciseTiming-pst': [1, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 1],
  'exerciseTiming-ref': [0, 1, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0],
  'exerciseTiming-bke': [1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0],
  'exerciseTiming-win': [1, 1, 0, 0, 0, 1, 1, 0, 1, 0, 0, -1],
  'exerciseTiming-none': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
}
export function generateArchetype(selections) {
  // Extract the selected options
  const selectedOptions = {}
  const selectedDescriptions = {}
  protocolAxes.forEach((axis) => {
    const selectedValue = selections[axis.id]
    const selectedOption = axis.options.find(
      (opt) => opt.value === selectedValue,
    )
    if (selectedOption) {
      selectedOptions[axis.id] = selectedOption.label
      selectedDescriptions[axis.id] = {
        category: axis.label,
        label: selectedOption.label,
        description: selectedOption.description,
        explanation: axis.explanation,
      }
    }
  })
  // Generate protocol name based on selections
  const identity =
    selections.identity?.charAt(0).toUpperCase() +
      selections.identity?.slice(1) || ''
  const mealFrequency =
    selections.mealFrequency?.charAt(0).toUpperCase() +
      selections.mealFrequency?.slice(1) || ''
  const foodType = selections.foodType || ''
  const macroStrategy = selections.macroStrategy || ''
  // First part of the protocol name (before the pipe)
  let namePart1 = ''
  if (identity && mealFrequency && foodType && macroStrategy) {
    namePart1 = `${identity} ${mealFrequency} ${foodType}${macroStrategy}`
  } else if (mealFrequency && foodType && macroStrategy) {
    namePart1 = `${mealFrequency} ${foodType}${macroStrategy}`
  } else if (identity && foodType && macroStrategy) {
    namePart1 = `${identity} ${foodType}${macroStrategy}`
  } else {
    namePart1 = 'Custom Protocol'
  }
  // Second part of the protocol name (after the pipe)
  const feedingCycle = selections.feedingCycle || ''
  const microStrategy =
    selections.microStrategy?.charAt(0).toUpperCase() +
      selections.microStrategy?.slice(1) || ''
  const exerciseTiming = selections.exerciseTiming?.toUpperCase() || ''
  let namePart2 = ''
  if (feedingCycle && microStrategy && exerciseTiming) {
    namePart2 = `${feedingCycle} ${microStrategy}-${exerciseTiming}`
  } else if (feedingCycle && exerciseTiming) {
    namePart2 = `${feedingCycle} ${exerciseTiming}`
  } else if (microStrategy && exerciseTiming) {
    namePart2 = `${microStrategy}-${exerciseTiming}`
  } else {
    namePart2 = 'Standard'
  }
  // Complete protocol name
  const name = `${namePart1} | ${namePart2}`
  // Generate tags
  const tags = Object.values(selectedOptions)
  // Generate comprehensive description that combines all effects
  let description = ''
  // Add identity effects if selected
  if (selectedDescriptions.identity) {
    description += `Your protocol is based on ${selectedDescriptions.identity.description}. `
  }
  // Add meal frequency effects if selected
  if (selectedDescriptions.mealFrequency) {
    description += `You follow a pattern of ${selectedDescriptions.mealFrequency.description}, which ${selectedDescriptions.mealFrequency.explanation.toLowerCase()} `
  }
  // Add food type effects if selected
  if (selectedDescriptions.foodType) {
    description += `Your diet is centered around ${selectedDescriptions.foodType.description}. `
  }
  // Add macronutrient strategy effects if selected
  if (selectedDescriptions.macroStrategy) {
    description += `You emphasize a ${selectedDescriptions.macroStrategy.description} approach to macronutrients. `
  }
  // Add micronutrient strategy effects if selected
  if (selectedDescriptions.microStrategy) {
    description += `For micronutrients, you focus on ${selectedDescriptions.microStrategy.description}. `
  }
  // Add feeding cycle effects if selected
  if (selectedDescriptions.feedingCycle) {
    description += `Your feeding cycle follows ${selectedDescriptions.feedingCycle.description}. `
  }
  // Add exercise timing effects if selected
  if (selectedDescriptions.exerciseTiming) {
    description += `Around workouts, you practice ${selectedDescriptions.exerciseTiming.description}. `
  }
  // If no selections were made, provide a default description
  if (description === '') {
    description =
      'Your personalized nutrition protocol is based on your unique selections and preferences.'
  }
  // Generate recommendations
  const recommendations = `Based on your ${namePart1} protocol, we recommend focusing on ${selectedOptions.mealFrequency || 'balanced meal timing'} while emphasizing ${selectedOptions.foodType || 'quality food sources'} and maintaining a ${selectedOptions.macroStrategy || 'balanced'} macronutrient ratio. 
For optimal fitness results, follow the ${feedingCycle || 'regular'} feeding cycle with ${selectedOptions.microStrategy || 'diverse micronutrient sources'} to support your ${selectedOptions.exerciseTiming || 'exercise performance'}.`
  // Generate radar data based on the data table values
  const radarData = radarAxes.map((axis, index) => {
    // Start with a base score of 0 (instead of 3)
    let score = 0
    // Add the contribution from each selection
    Object.entries(selections).forEach(([key, value]) => {
      const scoreKey = `${key}-${value}`
      if (
        dimensionScores[scoreKey] &&
        dimensionScores[scoreKey][index] !== undefined
      ) {
        // Add the score from the table
        score += dimensionScores[scoreKey][index]
      }
    })
    // Ensure the score doesn't go below 0
    score = Math.max(0, score)
    // Cap the maximum score at 5 to maintain the radar chart scale
    score = Math.min(5, score)
    return {
      axis: axis.label,
      value: score,
    }
  })
  return {
    name,
    description,
    tags,
    selections: selectedOptions,
    radarData,
    recommendations,
  }
}
